var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{staticClass:"mt-12",attrs:{"color":"error","timeout":"-1","top":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.close()}}},[_vm._v(" "+_vm._s(_vm.$t('common.close'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }